/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

export const supportedLanguages = [
  {language: 'english', code: 'english'},
  {language: 'chinese', code: 'chinese'},
  {language: 'german', code: 'german'},
  {language: 'spanish', code: 'spanish'},
  {language: 'russian', code: 'russian'},
  {language: 'korean', code: 'korean'},
  {language: 'french', code: 'french'},
  {language: 'japanese', code: 'japanese'},
  {language: 'portuguese', code: 'portuguese'},
  {language: 'turkish', code: 'turkish'},
  {language: 'polish', code: 'polish'},
  {language: 'catalan', code: 'catalan'},
  {language: 'dutch', code: 'dutch'},
  {language: 'arabic', code: 'arabic'},
  {language: 'swedish', code: 'swedish'},
  {language: 'italian', code: 'italian'},
  {language: 'indonesian', code: 'indonesian'},
  {language: 'hindi', code: 'hindi'},
  {language: 'finnish', code: 'finnish'},
  {language: 'vietnamese', code: 'vietnamese'},
  {language: 'hebrew', code: 'hebrew'},
  {language: 'ukrainian', code: 'ukrainian'},
  {language: 'greek', code: 'greek'},
  {language: 'malay', code: 'malay'},
  {language: 'czech', code: 'czech'},
  {language: 'romanian', code: 'romanian'},
  {language: 'danish', code: 'danish'},
  {language: 'hungarian', code: 'hungarian'},
  {language: 'tamil', code: 'tamil'},
  {language: 'norwegian', code: 'norwegian'},
  {language: 'thai', code: 'thai'},
  {language: 'urdu', code: 'urdu'},
  {language: 'croatian', code: 'croatian'},
  {language: 'bulgarian', code: 'bulgarian'},
  {language: 'lithuanian', code: 'lithuanian'},
  {language: 'latin', code: 'latin'},
  {language: 'maori', code: 'maori'},
  {language: 'malayalam', code: 'malayalam'},
  {language: 'welsh', code: 'welsh'},
  {language: 'slovak', code: 'slovak'},
  {language: 'telugu', code: 'telugu'},
  {language: 'persian', code: 'persian'},
  {language: 'latvian', code: 'latvian'},
  {language: 'bengali', code: 'bengali'},
  {language: 'serbian', code: 'serbian'},
  {language: 'azerbaijani', code: 'azerbaijani'},
  {language: 'slovenian', code: 'slovenian'},
  {language: 'kannada', code: 'kannada'},
  {language: 'estonian', code: 'estonian'},
  {language: 'macedonian', code: 'macedonian'},
  {language: 'breton', code: 'breton'},
  {language: 'basque', code: 'basque'},
  {language: 'icelandic', code: 'icelandic'},
  {language: 'armenian', code: 'armenian'},
  {language: 'nepali', code: 'nepali'},
  {language: 'mongolian', code: 'mongolian'},
  {language: 'bosnian', code: 'bosnian'},
  {language: 'kazakh', code: 'kazakh'},
  {language: 'albanian', code: 'albanian'},
  {language: 'swahili', code: 'swahili'},
  {language: 'galician', code: 'galician'},
  {language: 'marathi', code: 'marathi'},
  {language: 'punjabi', code: 'punjabi'},
  {language: 'sinhala', code: 'sinhala'},
  {language: 'khmer', code: 'khmer'},
  {language: 'shona', code: 'shona'},
  {language: 'yoruba', code: 'yoruba'},
  {language: 'somali', code: 'somali'},
  {language: 'afrikaans', code: 'afrikaans'},
  {language: 'occitan', code: 'occitan'},
  {language: 'georgian', code: 'georgian'},
  {language: 'belarusian', code: 'belarusian'},
  {language: 'tajik', code: 'tajik'},
  {language: 'sindhi', code: 'sindhi'},
  {language: 'gujarati', code: 'gujarati'},
  {language: 'amharic', code: 'amharic'},
  {language: 'yiddish', code: 'yiddish'},
  {language: 'lao', code: 'lao'},
  {language: 'uzbek', code: 'uzbek'},
  {language: 'faroese', code: 'faroese'},
  {language: 'haitian creole', code: 'haitian creole'},
  {language: 'pashto', code: 'pashto'},
  {language: 'turkmen', code: 'turkmen'},
  {language: 'nynorsk', code: 'nynorsk'},
  {language: 'maltese', code: 'maltese'},
  {language: 'sanskrit', code: 'sanskrit'},
  {language: 'luxembourgish', code: 'luxembourgish'},
  {language: 'myanmar', code: 'myanmar'},
  {language: 'tibetan', code: 'tibetan'},
  {language: 'tagalog', code: 'tagalog'},
  {language: 'malagasy', code: 'malagasy'},
  {language: 'assamese', code: 'assamese'},
  {language: 'tatar', code: 'tatar'},
  {language: 'hawaiian', code: 'hawaiian'},
  {language: 'lingala', code: 'lingala'},
  {language: 'hausa', code: 'hausa'},
  {language: 'bashkir', code: 'bashkir'},
  {language: 'javanese', code: 'javanese'},
  {language: 'sundanese', code: 'sundanese'},
  {language: 'cantonese', code: 'cantonese'},
  {language: 'burmese', code: 'burmese'},
  {language: 'valencian', code: 'valencian'},
  {language: 'flemish', code: 'flemish'},
  {language: 'mandarin', code: 'mandarin'},
];
